import { useEffect, useState, useCallback } from 'react';
import {
    Box, Avatar, Tag, useToast, Stack,
    Heading, StackDivider, Text, Flex, Link as ChakraLink
} from '@chakra-ui/react';
import DriverService from '../services/DriverService';
import CommonService from '../services/CommonService';
import config from '../constants/config';

import { Link, useLocation } from 'react-router-dom';

import { getVehicleType, getStatus } from '../utils/helper';

const Kyc = () => {

    const user = JSON.parse(localStorage.getItem("user"));
    const location = useLocation();
    const isDriver = location.pathname.includes("driver")

    const [data, setData] = useState([]);
    const [kycFlag, setkycFlag] = useState(false)
    const [kyc, setkyc] = useState(0)
    const [comp, setComp] = useState(0)
    const [vehicleStat, setVehicleStat] = useState(0)
    const [kycData, setKycData] = useState()
    const backendUrl = config.apiBaseUrl;
    const toast = useToast();

    const vehicleListing = useCallback(async () => {
        setData([]);
        try {
            const res = await DriverService.getVehicleList(user.uId);
            setData(res.data);
        } catch (error) {
            toast({
                title: 'Error',
                description: 'Error fetching Vehicle List',
                status: 'error',
                duration: 3000,
                isClosable: true,
                position: 'top-right',
            });
        }
    }, [user?.uId])

    const kycTest = useCallback(async () => {
        const params = {
            uId: user.uId,
            authToken: user.authToken
        };

        setkycFlag(0);
        try {
            const res = await CommonService.checkKYC(params);
            if (res.statusCode === 200) {
                setkyc(res.data.kycStat)
                setComp(res.data.compStat)
                setVehicleStat(res?.data?.vehicleStat !== undefined ? res?.data?.vehicleStat : 0)
                setKycData(res.data)
                if (res.data.kycStat === 5 && res.data.compStat === 5) {
                    setkycFlag(1);
                }
            }
        } catch (error) {
            toast({
                title: 'Error',
                description: 'Error fetching kyc',
                status: 'error',
                duration: 3000,
                isClosable: true,
                position: 'top-right',
            });
        }
    }, [user?.uId])

    useEffect(() => {
        vehicleListing();
        kycTest();
    }, [vehicleListing, kycTest]);

    return (
        <Box maxW="1000px" mx="auto" px={4}>

            <Box maxW="900px" mx="auto" mt={2}>
                {/* Profile Info Header */}
                <Box bg="blue.500" color="white" py={3} px={6} borderTopRadius="lg">
                    <Heading size="sm">KYC</Heading>
                </Box>
                <Box
                    bg="white"
                    p={6}
                    roundedBottom="xl"
                    boxShadow="md"
                    border="1px solid"
                    borderColor="gray.200"
                >
                    <Stack divider={<StackDivider />} spacing='4'>

                        <Flex pt="2" fontSize="sm" align="center" gap={2}>
                            <Text mb={0}>
                                {kyc === 5 ? 'KYC Approved' : 'KYC is Pending'}
                            </Text>
                            {kycFlag === 0 && (
                                <ChakraLink as={Link}
                                    to={user.role === 1 ? "/driver/profile" : "/user/profile"}
                                    color="blue.500" fontWeight="semibold">
                                    Go to KYC Portal
                                </ChakraLink>
                            )}
                        </Flex>
                        <Flex pt="2" fontSize="sm" align="center" gap={2}>
                            <Text>
                                {comp === 5 ? 'Company Approved' : 'Company Approval is pending'}
                            </Text>
                        </Flex>

                    </Stack>
                </Box>
            </Box>

            <Box maxW="900px" mx="auto" mt={4}>
                {
                    isDriver && data?.length == 0 && (
                        <>
                            <Text mb={0} >
                                Note: Approval status will be updated here.
                            </Text>
                            <Flex pt="2" fontSize="sm" align="center" gap={2}>
                                <Text mb={0}>
                                    Vehicle details must be added to continue.
                                </Text>
                                <ChakraLink as={Link}
                                    to={"/driver/vehicle"}
                                    color="blue.500" fontWeight="semibold">
                                    Add Vehilce
                                </ChakraLink>
                            </Flex>
                        </>
                    )
                }
                <Stack spacing={4} mt={3}>
                    {data.map((row) => (
                        <Box
                            key={row.DVNo}
                            p={4}
                            borderWidth="1px"
                            borderRadius="lg"
                            bg="white"
                            boxShadow="lg"
                        >
                            {/* Header */}
                            <Flex align="center" mb={3}>
                                <Avatar
                                    src={`${backendUrl}/vehicle/${row.vehiclePic}`}
                                    name={row.VMake}
                                    size="md"
                                    mr={3}
                                />
                                <Box>
                                    <Text fontWeight="bold" fontSize="lg">
                                        {row.VMake}
                                    </Text>
                                    <Text fontSize="sm" color="gray.500">
                                        {getVehicleType(row.VTyp)}
                                    </Text>
                                </Box>
                            </Flex>

                            {/* Vehicle Info */}
                            <Flex justify="space-between" align="center" mb={2}>
                                <Text><b>Model:</b> {row.VModel}</Text>
                                <Text><b>No:</b> {row.VNo}</Text>
                            </Flex>
                            <Flex justify="space-between" align="center" mb={2}>
                                <Text><b>Engine No:</b> {row.VEngNo}</Text>
                                <Text><Tag colorScheme="yellow">{row.VColor}</Tag></Text>
                            </Flex>
                            <Flex align="center" mb={2}>
                                <Text><b>Status : </b></Text>
                                <Text><Tag colorScheme="green">{getStatus(row.Stat)}</Tag></Text>
                            </Flex>

                        </Box>
                    ))}
                </Stack>
            </Box>

        </Box>
    )
}

export default Kyc
